import { AnimatePresence, motion } from 'framer-motion';
import styles from './Table.module.css';

export const Table = ({
  rows,
  cols,
  messages,
  scaleMsg,
  msgFontSize,
  animRotateDuration,
  animMovementDelay,
  animMovementDuration,
  animGlareDuration,
}) => {
  if (!rows?.length || !cols?.length) {
    return;
  }

  const widthCol = 181 / cols.length; // padding App 4rem, width rowNameBlock 15rem - all 200rem=1920px
  const heightRow = 92.5 / rows.length; // title 10rem, cols 8rem,  padding App 2rem- all 112.5rem=1080px

  const stringValue = messages.map((m) => m.col?.start + ',' + m.row?.start);

  let res = [];
  let isColize = [];
  let texts = [];

  stringValue.forEach((el) => {
    if (!res.includes(el)) {
      res.push(el);
    } else {
      if (!isColize.includes(el)) {
        const messagesColize = messages.filter(
          (m) => m.col?.start + ',' + m.row?.start === el
        );

        isColize.push(el);
        texts.push({
          colize: el,
          messages: [
            ...messagesColize
              .slice(0, messagesColize.length - 1)
              .map((m) => m.message.id),
          ],
        });
      }
    }
  });

  return (
    <div
      className={styles.wrapper}
      style={{
        gridTemplateColumns: `repeat(${cols.length}, minmax(10rem, 100rem))`,
        gridTemplateRows: `repeat(${rows.length}, minmax(10rem, 100rem))`,
      }}>
      <div>
        <ul className={styles.cols}>
          {cols.map((col) => (
            <li
              key={col}
              style={{ width: `${widthCol}rem` }}
              className={styles.colName}>
              {col}
            </li>
          ))}
        </ul>
        <div className={styles.rowsBlock}>
          <ul className={styles.rows}>
            {rows.map((row) => (
              <li
                key={row}
                style={{ height: `${heightRow}rem` }}
                className={styles.rowNameBlock}>
                <div className={styles.rowName}>{row}</div>
              </li>
            ))}
          </ul>
          <div className={styles.ceils}>
            {messages.map((msg) => {
              const positionString = msg.col?.start + ',' + msg.row?.start;
              const isColizeMsg = isColize.includes(positionString);
              let hiddenMsg = false;

              if (
                isColizeMsg &&
                texts
                  .find((c) => c.colize === positionString)
                  .messages.includes(msg.message.id)
              ) {
                hiddenMsg = true;
              }
              return (
                <AnimatePresence mode="wait" key={msg.message.id}>
                  {msg.col?.start && msg.row?.start && (
                    <motion.div
                      initial={{
                        position: 'absolute',
                        left: '46%',
                        top: '45%',
                        x: '-50%',
                        y: '-50%',
                        rotateX: '-90deg',
                        scale: scaleMsg,
                        zIndex: 10,
                      }}
                      animate={{
                        transition: {
                          rotateX: {
                            duration: animRotateDuration,
                          },
                          left: {
                            delay: animMovementDelay,
                            duration: animMovementDuration,
                          },
                          top: {
                            delay: animMovementDelay,
                            duration: animMovementDuration,
                          },
                          x: {
                            delay: animMovementDelay,
                            duration: animMovementDuration,
                          },
                          y: {
                            delay: animMovementDelay,
                            duration: animMovementDuration,
                          },
                          scale: {
                            delay: animMovementDelay,
                            duration: animMovementDuration,
                          },
                          zIndex: {
                            delay: animMovementDelay + animMovementDuration,
                            duration: animGlareDuration,
                          },
                        },
                        position: 'absolute',
                        left: `${(msg.col?.start - 1) * widthCol}rem`,
                        top: `${(msg.row?.start - 1) * heightRow}rem`,
                        x: 0,
                        y: 0,
                        rotateX: 0,
                        scale: 1,
                        zIndex: 5,
                      }}
                      exit={{
                        scale: 0,
                      }}
                      key={msg.col?.start + msg.row?.start}
                      className={styles.item}
                      style={{
                        gridColumnStart: msg.col?.start,
                        gridRowStart: msg.row?.start,
                        width: `${widthCol}rem`,
                        height: `${heightRow}rem`,
                      }}>
                      <div
                        className={`${styles.card} ${
                          hiddenMsg ? styles.hiddenMsg : ''
                        }`}
                        style={{ fontSize: `${msgFontSize}rem` }}>
                        <motion.div
                          initial={{
                            left: '-100%',
                          }}
                          animate={{
                            left: '100%',
                          }}
                          transition={{
                            delay: animRotateDuration,
                            duration: animGlareDuration,
                          }}
                          className={styles.light}
                        />
                        {msg.message.content.trim()}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
